import React, { useState, useEffect, useRef } from 'react';
import '../styles/Achievements.css';

const achievements = [
  {
    title: "ISO 9001 Certified",
    description: "Awarded for maintaining international quality standards.",
    icon: "🏆"
  },
  {
    title: "Top Exporter 2023",
    description: "Recognized as the top exporter in the textile category.",
    icon: "🌍"
  },
  {
    title: "Best Employer Award",
    description: "Honored for outstanding employee welfare programs.",
    icon: "👨‍💼"
  },
  {
    title: "Innovation Leader",
    description: "Recognized for innovative product development.",
    icon: "💡"
  },
  {
    title: "Sustainability Champion",
    description: "Awarded for eco-friendly manufacturing processes.",
    icon: "🌱"
  }
];

function Achievements() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const visibleCount = 3;
  const total = achievements.length;
  const intervalRef = useRef(null);

  const goNext = () => {
    setCurrentIndex((prev) => (prev + 1) % total);
  };

  const goPrev = () => {
    setCurrentIndex((prev) => (prev - 1 + total) % total);
  };

  // Setup auto-scroll
  useEffect(() => {
    intervalRef.current = setInterval(goNext, 1000); // Change every 3 seconds

    return () => clearInterval(intervalRef.current); // Cleanup on unmount
  }, []);

  const visibleAchievements = achievements.slice(currentIndex, currentIndex + visibleCount);
  const displayItems =
    visibleAchievements.length < visibleCount
      ? [...visibleAchievements, ...achievements.slice(0, visibleCount - visibleAchievements.length)]
      : visibleAchievements;

  return (
    <section className="achievements-section" id="achievements">
      <div className="achievements-header">
        <h2 className="section-title">OUR ACHIEVEMENTS</h2>
        <div className="achievements-nav-buttons">
          <button onClick={goPrev} className="achievements-nav-btn">&larr;</button>
          <button onClick={goNext} className="achievements-nav-btn">&rarr;</button>
        </div>
      </div>

      <div className="achievements-container">
        {displayItems.map((item, index) => (
          <div className="achievement-card" key={index}>
            <div className="achievement-icon">{item.icon}</div>
            <h3 className="achievement-title">{item.title}</h3>
            <p className="achievement-description">{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Achievements;
